import classNames from 'classnames';
import { Button, Icon, SvgAnimation } from '@/components/standalone';
import { useRef } from 'react';
import useOnScreen from '@/helpers/useOnScreen';
import styles from '@/styles/personae.module.scss';

function AuditorsPublishSection() {
  const headingRef = useRef();
  const { isOnScreen: isHeadingOnScreen } = useOnScreen({
    ref: headingRef,
    threshold: 0.3,
    rootMargin: '0px',
    isOnce: true,
  });

  const animationRef = useRef();
  const { isOnScreen: isAnimationOnScreen } = useOnScreen({
    ref: animationRef,
    threshold: 0.5,
    rootMargin: '0px',
    isOnce: true,
  });

  return (
    <div
      className={classNames(
        'section',
        styles.personaeSection,
        styles.personaeSectionPublish,
      )}
    >
      <div className={classNames('max-content-width', styles.classic)}>
        <div
          className={classNames(styles.personaeSectionText, {
            [styles.personaeSectionTextAppear]: isHeadingOnScreen,
          })}
          ref={headingRef}
        >
          <div className="tb-tag">
            <Icon name="Send" />
            PUBLISH AUDITS
          </div>
          <h2>Frictionless use at no cost</h2>
          <p>
            Publish your audits by either using our website or our api. Benefit
            from all Trustblock’s advantages to enhance your business and help
            web3 thrive at no cost.
          </p>
          <Button
            type="link"
            href="https://docs.trustblock.run/technical-documentation/publish-an-audit"
            icon="ArrowUpRight"
            mode="primary"
          >
            Learn more
          </Button>
        </div>
        <div
          ref={animationRef}
          className={classNames(
            styles.personaeSectionAnimation,
            styles.spaced,
            styles.personaeSectionAnimationPublish,
          )}
        >
          <SvgAnimation
            name="Publish"
            autoplay={isAnimationOnScreen}
            onComplete={(animation) => {
              animation.playSegments(
                [3.59 * 60, animation.getDuration() * 60],
                true,
              );
              // eslint-disable-next-line no-param-reassign
              animation.loop = true;
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default AuditorsPublishSection;
